export default {
  init (vue) {
    return {
      signin (data) {
        return vue.$http({
          method: 'POST',
          url: '/api/auth',
          data: data
        })
      },
      isSigned() {
        const _token = localStorage.getItem('access_token')
        return !!_token
      }
    }
  }
}
